﻿import { useQuery, useMutation, useQueryClient } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";

import { getCodes, getCode, saveCode, deleteCode, restoreCode } from "@/api/Maintainers/codes";

const key = "codes";

export function useCode(selected) {
	return useQuery([key, selected], () => selected && getCode({ selected }));
}

export function useCodesPaginate(params) {
	return useQuery([key, params], () => getCodes(params));
}

export function useMutateCode(params) {
	const navigate = useNavigate();
	const location = useLocation();
	const queryClient = useQueryClient();

	return useMutation(saveCode, {
		onSuccess: (response) => {
			const codes = _.omit(response, "detail");
			const code = _.omit(response, key);

			queryClient.setQueryData([key, String(code.detail.id)], code);
			queryClient.setQueryData([key, params], codes);

			if (params.search) {
				queryClient.invalidateQueries([key]);
			}

			if (location.state) {
				navigate(location.state);
				return;
			}

			navigate("/mantenedores/codes");
		},
	});
}

export function useMutateDeleteCode(params) {
	const queryClient = useQueryClient();

	return useMutation(deleteCode, {
		onSuccess: (response) => {
			queryClient.setQueryData([key, params], response);
		},
	});
}

export function useMutateRestoreCode(params) {
	const queryClient = useQueryClient();

	return useMutation(restoreCode, {
		onSuccess: (response) => {
			queryClient.setQueryData([key, params], response);
		},
	});
}
